import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export default function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          <Link to="/" className="flex items-center space-x-3">
            <img src="/hollis-massage-logo.png" alt="Hollis Massage Logo" className="w-14 h-14" />
            <span className="text-2xl font-bold text-teal-700">Hollis Massage</span>
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            <Link to="/" className="text-lg font-medium text-gray-700 hover:text-teal-600 transition">
              Home
            </Link>
            <Link to="/services" className="text-lg font-medium text-gray-700 hover:text-teal-600 transition">
              Services
            </Link>
           <Link to="/About" className="text-lg font-medium text-gray-700 hover:text-teal-600 transition">
              About
            </Link>
          </div>
          
          {/* Book Now Button 
          <Link 
            to="/book" 
            className="hidden md:block bg-teal-600 text-white px-6 py-2 rounded-lg text-lg font-semibold hover:bg-teal-700 transition"
          >
            Book Now
          </Link>*/}
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-700"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 pt-2 pb-4 space-y-2">
            <Link 
              to="/" 
              onClick={() => setMobileMenuOpen(false)}
              className="block py-2 text-lg font-medium text-gray-700 hover:text-teal-600"
            >
              Home
            </Link>
            <Link 
              to="/services" 
              onClick={() => setMobileMenuOpen(false)}
              className="block py-2 text-lg font-medium text-gray-700 hover:text-teal-600"
            >
              Services
            </Link>
            <Link 
              to="/about" 
              onClick={() => setMobileMenuOpen(false)}
              className="block py-2 text-lg font-medium text-gray-700 hover:text-teal-600"
            >
              About
            </Link>
            {/*<Link 
              to="/book" 
              onClick={() => setMobileMenuOpen(false)}
              className="block bg-teal-600 text-white px-6 py-2 rounded-lg text-center text-lg font-semibold hover:bg-teal-700 transition mt-2"
            >
              Book Now
            </Link>*/}
          </div>
        </div>
      )}
    </nav>
  );
}